import AxiosInstance from "axios";
import Cookies from "js-cookie";
import { BASE_URL } from "utils/constants";

const axios = AxiosInstance.create({
    baseURL: BASE_URL + "/api/v1",
    withCredentials: true,
    headers: { Accept: "application/json" },
});

// Helper: ambil token SSO dari localStorage
const getSanctumToken = () => {
    return localStorage.getItem("sanctum_token");
};

// Request interceptor (jalan sebelum request dikirim)
const onRequest = async (config) => {
    // 1) Kalau ada token SSO, kirim sebagai Bearer token
    const token = getSanctumToken();
    if (token) {
        config.headers = config.headers ?? {};
        config.headers.Authorization = `Bearer ${token}`;
    }

    // 2) Pertahankan behavior lama: CSRF cookie untuk request state-changing
    const method = (config.method || "get").toLowerCase();
    const needsCsrf =
        method === "post" || method === "put" || method === "delete" || method === "patch";

    // ⚠️ Kalau request kamu pakai Bearer token (SSO), sebenarnya CSRF tidak wajib.
    // Tapi tidak masalah tetap mempertahankan mekanisme lama untuk kompatibilitas.
    if (needsCsrf && !Cookies.get("XSRF-TOKEN")) {
        await setCSRFToken();
    }

    return config;
};

// Set CSRF cookie (Sanctum stateful)
const setCSRFToken = () => {
    return axios.get("/sanctum/csrf-cookie", {
        baseURL: BASE_URL,
    });
};

axios.interceptors.request.use(onRequest, (error) => Promise.reject(error));

export default axios;
